import React from 'react';

function CustomChartWidgetSettings() {
  return (
    null
  )
}

export default CustomChartWidgetSettings;